/* Trend Commerce launch helpers: fixed-window promotional countdown, code copy, sticky CTA.
   Promotions read data-start / data-end (ISO 8601) from [data-tc-promo] and [data-tc-promo-offer] elements. */
(() => {
  let timer = null;

  const pad = (n) => String(n).padStart(2, '0');

  const WEEK = 7 * 86400000;

  // Pure helper. Fixed mode: one window [start, end). Weekly mode: window N = start + N x 7 days, and the
  // countdown targets the end of the window containing "now". Before the start nothing is active.
  function currentWindow(start, end, repeat, now) {
    if (!repeat) return { start, end, active: now >= start && now < end, ended: now >= end };
    if (now < start) return { start, end: start + WEEK, active: false, ended: false };
    const n = Math.floor((now - start) / WEEK);
    return { start: start + n * WEEK, end: start + (n + 1) * WEEK, active: true, ended: false };
  }

  function promoWindow(el, now) {
    const start = Date.parse(el.dataset.start);
    const end = Date.parse(el.dataset.end);
    const valid = !Number.isNaN(start) && !Number.isNaN(end) && end > start;
    const repeat = el.dataset.repeat === 'weekly';
    if (!valid) return { valid: false, active: false, ended: true, repeat };
    return { valid, repeat, ...currentWindow(start, end, repeat, now) };
  }

  const formatEnd = (ms) => {
    try {
      return new Date(ms).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
    } catch (e) {
      return new Date(ms).toLocaleString();
    }
  };

  // A promotion is shown only inside its fixed window. Once it ends it stays hidden; it never restarts
  // (unless weekly repeat is on, which the owner must only enable when the discount is really re-issued).
  function updatePromos() {
    const now = Date.now();
    let pending = false;
    document.querySelectorAll('[data-tc-promo-offer]').forEach((el) => {
      const w = promoWindow(el, now);
      el.hidden = !w.active;
      if (w.valid && !w.ended) pending = true;
    });
    document.querySelectorAll('[data-tc-promo-fallback]').forEach((el) => {
      el.hidden = promoWindow(el, now).active;
    });
    document.querySelectorAll('[data-tc-promo]').forEach((el) => {
      const w = promoWindow(el, now);
      el.hidden = !w.active;
      if (w.valid && !w.ended) pending = true;
      if (!w.active) return;
      const total = Math.floor((w.end - now) / 1000);
      const parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      el.querySelectorAll('[data-tc-unit]').forEach((u) => {
        const v = parts[u.dataset.tcUnit];
        u.textContent = u.hasAttribute('data-tc-nopad') ? String(v) : pad(v);
      });
      if (w.repeat) {
        el.querySelectorAll('[data-tc-end-label]').forEach((l) => {
          l.textContent = formatEnd(w.end);
        });
      }
    });
    return pending;
  }

  function tick() {
    const pending = updatePromos();
    if (!pending && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function startTimers() {
    tick();
    if (!timer) timer = setInterval(tick, 1000);
  }

  async function copyCode(btn) {
    const code = btn.dataset.tcCopy;
    const label = btn.querySelector('[data-tc-copy-label]');
    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      ta.remove();
    }
    if (label) {
      const original = label.dataset.original || label.textContent;
      label.dataset.original = original;
      label.textContent = 'Copied';
      btn.classList.add('is-copied');
      setTimeout(() => {
        label.textContent = original;
        btn.classList.remove('is-copied');
      }, 2000);
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tc-copy]');
    if (btn) copyCode(btn);
  });

  function initSticky() {
    const bar = document.querySelector('[data-tc-sticky]');
    const sentinel = document.querySelector('[data-tc-sticky-sentinel]');
    if (!bar) return;
    if (!sentinel || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }
    new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(sentinel);
  }

  function init() {
    startTimers();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.tcPromo = { currentWindow, WEEK };
})();
